import(/* webpackMode: "eager" */ "/app/apps/web/src/app/me/invite/page.tsx");
